module.exports = __webpack_public_path__ + "static/media/virtual-reality-coding.6c54db75.webp";